export function padWithLeadingZeros(numbers: string){
	let diffLength = 10 - numbers.length;
	if(diffLength === 0){
		return numbers;
	}
	let padding = new Array(diffLength + 1).join("0");
	return padding + numbers;
}

export function calculateCheckDigits(numbers:string){
	let n = parseInt(numbers, 10);
	let control = n % 97;
	control = control === 0 ? 97 : control;

	let r = control < 10 ? "0" + control : control.toString();
	return r;

}

export function isValidOGM(ogm:string){

	if(!ogm)
		return false;

	/*if(!/\+{3}[0-9]{3}\/[0-9]{4}\/[0-9]{5}\+{3}/.test(ogm)){
		return false;
	}*/

	let numbers = ogm.match(/\d+/g)?.join("");
	let firstTen = numbers?.substring(0, 10);
	if(!firstTen){
		return;
	}
	let control = numbers?.substring(10, 12);
	let result = calculateCheckDigits(firstTen);

	return result === control;
}

export function generateOGM(numbers:string){

	let n = numbers.replace(/\D/g,"");

	// built the string representation of the ogm.
	return n.substring(0, 3)
			+ "/" + n.substring(3,7)
			+ "/" + n.substring(7,12);

}